import { render, staticRenderFns } from "./PropertyAndClientDetails.vue?vue&type=template&id=ffb67c28&"
import script from "./PropertyAndClientDetails.vue?vue&type=script&lang=js&"
export * from "./PropertyAndClientDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports